export enum ConfirmationOfCorrectContractFieldName {
  FirstName = 'First Name',
  LastName = 'Last Name',
  Confirmation = 'Confirm that Contracts contains the information above',
}
